import { render, staticRenderFns } from "./TheQuote.vue?vue&type=template&id=9e32a638&scoped=true&"
import script from "./TheQuote.vue?vue&type=script&lang=js&"
export * from "./TheQuote.vue?vue&type=script&lang=js&"
import style0 from "./TheQuote.vue?vue&type=style&index=0&id=9e32a638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e32a638",
  null
  
)

export default component.exports